import React, { useRef } from "react";
import { OverlayTrigger, Tooltip as BootstrapTooltip } from "react-bootstrap";
import cx from 'classnames';
import styles from './tooltip.module.scss';
import { Placement } from "react-bootstrap/esm/types";

interface TooltipProps {
  show?: boolean;
  placement: Placement;
  className?: string;
  content?: string | React.ReactNode;
  children: React.ReactNode;
  disabled?: boolean;
  container?: HTMLElement;
}

const Tooltip: React.FC<TooltipProps> = ({show, placement, className, content, children, disabled }) => {
  const idRef = useRef(Math.random().toString(36).substring(7));

  if (!content || disabled) {
    return <>{children}</>;
  }

  return (
    <OverlayTrigger
      show={show}
      container={document.body}
      placement={placement}
      trigger={['hover', 'focus']}
      overlay={
        <BootstrapTooltip className={cx(styles.tooltip, className)} placement={placement} id={idRef.current}>
          {content}
        </BootstrapTooltip>
      }
    >
      {React.isValidElement(children) ? children : <span>{children}</span>}
    </OverlayTrigger>
  );
}

export default Tooltip;